import { Icon, ICONS, Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import styles from './MetricTags.module.scss';
import Tag from '../Tag';

const cx = classNames.bind(styles);

interface MetricTagsProps {
  firstTag: string;
  secondTag: string;
  date: string;
  infoTooltipText: string;
}

const MetricTags = ({ firstTag, secondTag, date, infoTooltipText }: MetricTagsProps): ReactElement => {
  return (
    <div className={cx('body')}>
      <span className={cx('tags')}>
        <Tag>{firstTag}</Tag>
        <Tag>{secondTag}</Tag>
      </span>
      <span className={cx('most-recent-date')}>
        As of {date}
        <Tooltip content={infoTooltipText}>
          <span className={cx('icon-wrapper')}>
            <Icon name={ICONS.Info} dataTestId="info-icon" height={12} width={12} />
          </span>
        </Tooltip>
      </span>
    </div>
  );
};

export default MetricTags;
